/** The marker in front of a tree item's title by its depth. */
export function getTitlePrefix(depth: number) {
	switch (depth) {
		case 0:
			return "\u2B1B";
		case 1:
			return "\u25FB";
		case 2:
			return "\u25A0";
		case 3:
			return "\u25AA";
		default:
			return "\u25AB";
	}
}
